/* /women トップとお支払い (/lp/pay) の Noto Sans JP、Noto Serif JP、IBM Plex Mono。
   Google Fonts の CSS は @font-face が 500 本ほどで 122KB あり、<link rel="stylesheet"> で書くと
   読み切るまで最初の描画が止まる。window の load の後に足せば止まらない。
   最初の画面の字は自前の切り出し (hp-css.ts の Women FV) で最初から出るので、
   ここで足すのは最初の画面より下の字の分だけ。
   読む太さは使う分だけ (ゴシック 400、700、900、明朝 700、等幅 400 と 600) */
export const HP_GOOGLE_FONTS_URL =
  "https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@400;700;900&family=Noto+Serif+JP:wght@700&family=IBM+Plex+Mono:wght@400;600&display=swap";

/* トップの女性向けのトーン (pages/index/sec-women-tone.ts) の見出しと手書きの字。v2 のトップ (.hp-tone-v2) と下層の頁 (.sub-w) にだけ、同じく load の後に足す。
   お支払いの頁の links に載る上の URL には混ぜない (描画を止める CSS が太るため)。
   足すのは上と別の script にする。書き出し (apps/women-astro の postbuild) は上の script を自前の字の束に置き換えて外すが、
   この 2 書体は束に無いので、こちらは残して同じく load の後に Google Fonts から読む */
export const HP_HOME_TONE_FONTS_URL =
  "https://fonts.googleapis.com/css2?family=Klee+One:wght@600&family=Zen+Kaku+Gothic+New:wght@500;700;900&display=swap";

const LINK_ID = "hp-google-fonts";
const TONE_LINK_ID = "hp-home-tone-fonts";
// 見出しの書体を足す頁の目印。トップ (.hp-tone-v2) と、下層の頁 (.sub-w、pages/lp/women-tone.ts の SUB_TONE_CLASS)
const TONE_SELECTOR = ".hp-tone-v2,.sub-w";
// ホーム (index.page.tsx の外枠) とお支払い (pay.page.tsx の外枠) が画面に出ているかの目印
const PAGE_SELECTORS = [".hp-home", ".pay"];

function sameUrlLinks(): HTMLLinkElement[] {
  return Array.from(
    document.querySelectorAll<HTMLLinkElement>('link[rel="stylesheet"]'),
  ).filter((link) => link.href === HP_GOOGLE_FONTS_URL);
}

function addToneStylesheet() {
  if (!document.querySelector(TONE_SELECTOR) || document.getElementById(TONE_LINK_ID)) return;
  const link = document.createElement("link");
  link.id = TONE_LINK_ID;
  link.rel = "stylesheet";
  link.href = HP_HOME_TONE_FONTS_URL;
  document.head.appendChild(link);
}

function addStylesheet() {
  // 離れたあとには足さない。料金や受講生の声が同じ URL を links で持つので、あるなら足さない
  if (!PAGE_SELECTORS.some((selector) => document.querySelector(selector))) return;
  if (sameUrlLinks().length > 0) return;
  const link = document.createElement("link");
  link.id = LINK_ID;
  link.rel = "stylesheet";
  link.href = HP_GOOGLE_FONTS_URL;
  document.head.appendChild(link);
}

/* load を待って足す。戻り値は待ちの解除と、離れたときの片付け。
   片付けは、足した link と同じ URL の link が他に出たとき (遷移先の links) に、
   向こうが読み終わってから足した分を外して 1 本に戻す。向こうが読み終わる前に外すと字が一瞬替わる */
export function loadHpGoogleFontsAfterLoad(): () => void {
  if (document.readyState === "complete") addStylesheet();
  else window.addEventListener("load", addStylesheet, { once: true });
  return () => {
    window.removeEventListener("load", addStylesheet);
    const mine = document.getElementById(LINK_ID);
    if (!mine) return;
    const other = sameUrlLinks().find((link) => link !== mine);
    if (!other) return;
    if (other.sheet) mine.remove();
    else other.addEventListener("load", () => mine.remove(), { once: true });
  };
}

/* ハイドレーションの前から動くよう、同じ処理を文字列にして本文に埋める。
   script は React が作る分では実行されないので、画面の中の遷移でここへ来た場合は
   下の effect が同じことをする。どちらが先でも link は 1 本だけ */
export const INLINE_LOADER = `(function(){var i=${JSON.stringify(LINK_ID)},u=${JSON.stringify(HP_GOOGLE_FONTS_URL)};function a(){if(!${JSON.stringify(PAGE_SELECTORS)}.some(function(q){return document.querySelector(q)}))return;var s=document.querySelectorAll('link[rel="stylesheet"]');for(var k=0;k<s.length;k++)if(s[k].href===u)return;var l=document.createElement("link");l.id=i;l.rel="stylesheet";l.href=u;document.head.appendChild(l)}if(document.readyState==="complete")a();else window.addEventListener("load",a,{once:true})})();`;

/* v2 のトップの 2 書体を load の後に足す。上と同じく、ハイドレーションの前から動く script と、画面の中の遷移で来たときの effect の両方から呼ぶ */
export function loadHpToneFontsAfterLoad(): () => void {
  if (document.readyState === "complete") addToneStylesheet();
  else window.addEventListener("load", addToneStylesheet, { once: true });
  return () => window.removeEventListener("load", addToneStylesheet);
}

export const TONE_INLINE_LOADER = `(function(){var i=${JSON.stringify(TONE_LINK_ID)},u=${JSON.stringify(HP_HOME_TONE_FONTS_URL)};function a(){if(!document.querySelector(${JSON.stringify(TONE_SELECTOR)})||document.getElementById(i))return;var l=document.createElement("link");l.id=i;l.rel="stylesheet";l.href=u;document.head.appendChild(l)}if(document.readyState==="complete")a();else window.addEventListener("load",a,{once:true})})();`;
